/**
 * Returns the preferred/default customer address when present, otherwise the
 * most recently added address from the address book. Falls back to the last
 * entry in the array when no `creationDate` metadata is available.
 *
 * @param {Array<Object>} addresses - Customer address book entries (SCAPI shape).
 * @returns {Object|undefined}
 */
export const getPreferredOrMostRecentAddress = (addresses) => {
    if (!addresses || addresses.length === 0) return undefined
    const preferred = addresses.find((addr) => addr.preferred === true)
    if (preferred) return preferred
    const withDates = addresses.filter((addr) => addr.creationDate)
    if (withDates.length > 0) {
        return withDates.reduce((latest, addr) =>
            new Date(addr.creationDate) > new Date(latest.creationDate) ? addr : latest
        )
    }
    return addresses[addresses.length - 1]
}

/**
 * Melissa collapses every unit of a multi-unit building into a single suggestion
 * whose `address2` is a comma-separated list (e.g. "Apt J301,Apt G312,Ofc").
 * Expands those into one suggestion per unit so each can be selected on its own.
 *
 * @param {Array<Object>} suggestions - Suggested addresses returned by address validation.
 * @returns {Array<Object>}
 */
export const expandAddressSuggestions = (suggestions) => {
    if (!suggestions || suggestions.length === 0) return []
    return suggestions.flatMap((suggestion) => {
        if (!suggestion.address2 || !suggestion.address2.includes(',')) return [suggestion]
        const units = suggestion.address2
            .split(',')
            .map((unit) => unit.trim())
            .filter(Boolean)
        if (units.length <= 1) return [suggestion]
        return units.map((unit) => ({...suggestion, address2: unit}))
    })
}
